import { useEffect, useState } from "react";
import Button1 from "../../form/Button1";
import TextInput from "../../form/TextInput";
import topupAgencyWallet from "../../../controllers/settings/wallet/topupAgencyWallet";
import PinForm from "../../Settings/PinForm";
import { useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";
import ModalContainer from "../../common/ModalContainer";

const CustomerDetailWalletTopUpModals = ({
  open,
  setOpen,
  data: defData,
  currency,
  reload,
  setLoading,
  loading,
}) => {
  const {
    userData: { user },
  } = useSelector((state) => state.user);
  const [data, setData] = useState({ ...(defData || {}), amount: undefined });
  const [openPin, setOpenPin] = useState(false);

  useEffect(() => {
    if (open) {
      setData({ ...(defData || {}), amount: undefined });
    }
  }, [open, defData]);

  const currencyLabel = currency?.code || currency?.symbol || "NGN";

  const handleTopUp = async (pin) => {
    if (user?.advancedSecurityEnabled && !pin) return setOpenPin(true);

    setLoading(true);
    const res = await topupAgencyWallet({
      accountId: data?._id,
      amount: Number(data?.amount),
      currency: currency?.code,
      pin,
    });
    setLoading(false);
    if (res.return) {
      enqueueSnackbar("Wallet credited successully", { variant: "success" });
      setOpen(false);
      reload?.();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  };

  return (
    <>
      <ModalContainer
        open={open}
        setOpen={setOpen}
        title="Top-up balance"
        subTitle={
          currency
            ? `${currency.name} (${currency.code})`
            : undefined
        }
      >
        <div className="p-4 flex flex-col gap-6 max-w-[800px]">
          <TextInput
            label="Amount"
            type="number"
            value={data.amount}
            onChange={(ev) => setData({ ...data, amount: ev.target.value })}
            InputProps={{
              endAdornment: currencyLabel,
            }}
          />
        </div>
        <div className="flex gap-2 p-4">
          <Button1 className="btn-theme-light" onClick={() => setOpen(false)}>
            Cancel
          </Button1>
          <Button1
            loading={loading}
            onClick={() => setOpenPin(true)}
            className={"whitespace-nowrap"}
          >
            Save Changes
          </Button1>
        </div>
      </ModalContainer>
      <ModalContainer
        title={"PIN"}
        open={openPin}
        setOpen={() => handleTopUp()}
      >
        <PinForm
          callback={(pin) => {
            setOpenPin(false);
            handleTopUp(pin);
          }}
          close={() => setOpenPin(false)}
        />
      </ModalContainer>
    </>
  );
};

export default CustomerDetailWalletTopUpModals;
